import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownListItemComponent } from './dropdown-list-item/dropdown-list-item.component';
import { DropdownListComponent } from './dropdown-list.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { HtmlFormatPipeModule } from 'src/app/pipes/html-format-pipe.module';
import { PricePipeModule } from 'src/app/pipes/price.module';


@NgModule({
  declarations: [
    DropdownListItemComponent,
    DropdownListComponent,
  ],
  imports: [
    CommonModule,
    AngularSvgIconModule,
    TranslateModule,
    HtmlFormatPipeModule,
    PricePipeModule,
  ],
  exports: [
    DropdownListComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class DropdownListModule { }
